export default __webpack_public_path__ + "b0a5f2afec56ed15ff02b7225b8f3ea0.svg";